module.exports = __webpack_public_path__ + "img/smart_poster.fb45ab73.png";